import angular from 'angular';
import PaymentModeController from './paymentmode.controller';
import AddressController from './address.controller';
import PlaceOrderController from './place-order.controller';
import GuestController from './guest.controller';
import DeliveryInfoController from './deliveryinfo.controller';

let checkout = angular
    .module('checkout', [])
    .controller('GuestController', GuestController)
    .controller('PaymentModeController', PaymentModeController)
    .controller('PlaceOrderController', PlaceOrderController)
    .controller('AddressController', AddressController)
    .controller('DeliveryInfoController', DeliveryInfoController);

export default checkout;
